export default __webpack_public_path__ + "static/solutions-5-bad55da05aea391561917540031ce8b4.webp";